import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import logo from "../images/transparent-logo.png";
import { fetchViaPost } from "../helpers/fetchViaPost";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link
        color="inherit"
        href="https://betty.works/"
      >
        betty
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export function ResetPassword({
  setAuth,
}) {
  const params = useMemo(
    () =>
      new URLSearchParams(
        window.location.search
      ),
    []
  );

  const email =
    params.get("email") || "";

  const token =
    params.get("token") || "";

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const [success, setSuccess] =
    useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");

    const data =
      new FormData(
        event.currentTarget
      );

    const password =
      String(
        data.get("password") || ""
      );

    const passwordRepeat =
      String(
        data.get("passwordRepeat") || ""
      );

    if (!email || !token) {
      setError(
        "This reset link is invalid or incomplete."
      );
      return;
    }

    if (
      password.length === 0 ||
      passwordRepeat.length === 0
    ) {
      setError(
        "Please enter the new password twice."
      );
      return;
    }

    if (
      password !== passwordRepeat
    ) {
      setError(
        "The passwords do not match."
      );
      return;
    }

    setLoading(true);

    try {
      const response =
        await fetchViaPost(
          "reset-password",
          JSON.stringify({
            email,
            token,
            password,
          })
        );

      const result =
        await response.json();

      if (!result?.ok) {
        setError(
          result?.msg ||
            "The password could not be reset."
        );
        return;
      }

      setSuccess(true);
    } catch (err) {
      console.error(
        "[Reset Password]",
        err
      );

      setError(
        "The password could not be reset."
      );
    } finally {
      setLoading(false);
    }
  }

  function backToSignIn() {
    if (setAuth) {
      setAuth("sign-in");
    }

    window.location.pathname =
      "sign-in";
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
    >
      <CssBaseline />

      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={logo}
          alt="betty"
          style={{
            width: "10em",
          }}
        />

        <Typography
          component="h1"
          variant="h5"
        >
          Reset password
        </Typography>

        {!success ? (
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              mt: 2,
              width: "100%",
            }}
          >
            <Typography
              color="text.secondary"
              sx={{
                mb: 2,
              }}
            >
              Choose a new password
              for your betty account.
            </Typography>

            {error && (
              <Alert
                severity="error"
                sx={{ mb: 2 }}
              >
                {error}
              </Alert>
            )}

            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="New Password"
              type="password"
              id="password"
              autoComplete="new-password"
              autoFocus
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="passwordRepeat"
              label="Repeat New Password"
              type="password"
              id="passwordRepeat"
              autoComplete="new-password"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
              }}
            >
              Save new password
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              mt: 3,
              width: "100%",
            }}
          >
            <Alert
              severity="success"
              sx={{
                mb: 2,
              }}
            >
              Your password has been updated.
            </Alert>

            <Typography
              color="text.secondary"
            >
              You can now sign in
              with your new password.
            </Typography>
          </Box>
        )}

        <Button
          onClick={backToSignIn}
          sx={{
            mt: 2,
          }}
        >
          Back to Sign In
        </Button>
      </Box>

      <Copyright
        sx={{
          mt: 8,
          mb: 4,
        }}
      />
    </Container>
  );
}
